
























































































import {Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import {
  入庫作成依頼型,
  入庫候補商品バリデータ一覧,
  入庫候補商品型,
  入庫候補検索条件バリデータ一覧,
  入庫候補検索条件型,
  入庫マスタ選択区分型,
  商品ソート区分型,
  商品ソート区分一覧,
  仕入先を抜いた商品ソート区分一覧,
  確定対象である,
  入庫候補検索結果型,
} from '@/type/stock/receive/item';
import {ValidationResult} from '@/type/validation/result';
import {入庫入力型} from '@/type/stock/receive/unfixed';
import api from '@/infrastructure/api/api';
import {processModule} from '@/store/process/process';
import {progress} from '@/script/progress';
import StockReceiveWholesaleSelector from '@/views/stock/receive/StockReceiveWholesaleSelector.vue';
import NormalDialog from '@/components/atom/dialog/NormalDialog.vue';
import ConfirmDialog from '@/components/atom/dialog/ConfirmDialog.vue';
import NormalButton from '@/components/atom/button/NormalButton.vue';
import AmountField from '@/components/atom/input/AmountField.vue';
import {マスタ選択区分型} from '@/type/wholesale/types';

@Component({
  components: {
    StockReceiveWholesaleSelector,
    NormalDialog,
    ConfirmDialog,
    NormalButton,
    AmountField,
  },
})
export default class UnfixedItemSearch extends Vue {
  @Prop({default: false})
  private modal!: boolean;

  private 入庫候補商品検索条件: 入庫候補検索条件型 = this.検索条件初期値を取得();
  private 入庫候補商品一覧: 入庫候補商品型[] = [];

  private 検索条件バリデーション結果: ValidationResult = new ValidationResult(入庫候補検索条件バリデータ一覧);
  private 商品バリデーション結果: ValidationResult = new ValidationResult(入庫候補商品バリデータ一覧);

  private 選択中の行index: number|null = null;
  private 次の行index: number | null = null;
  private グリッド最終行: number | null = null;
  private グリッド件数: number | null = null;

  private beforeOpened: boolean = false;

  @Watch('入庫候補商品一覧.JANコード', {deep: true})
  private 数量にフォーカス(): void {
    this.$nextTick(() => {
      this.グリッド件数 = this.入庫候補商品一覧.length;
      if (this.beforeOpened === true && this.グリッド件数 > 0) {
        this.入力欄を指定().数量入力欄[0].$el.childNodes[0].focus();
        this.リスト選択時の処理(0);
      }
    });
  }

  private beforeOpen() {
    const 商品名カナ入力欄 = document.getElementById('商品名カナ');
    if (商品名カナ入力欄) {
      商品名カナ入力欄.focus();
    }
    this.beforeOpened = true;
  }

  private beforeUpdate() {
    this.検索条件バリデーション結果.validate(this.入庫候補商品検索条件);
    this.商品バリデーション結果.validateList(this.入庫候補商品一覧, 確定対象である);
  }

  private 検索開始に移動するハンドラ(keyCode: number, repeat: boolean) {
    if (keyCode !== 13) return;
    if (repeat === true) return;
    const 検索開始ボタン = document.getElementById('検索開始');
    if (!検索開始ボタン) return;
    検索開始ボタン.focus();
  }

  private 検索条件エラー判定(項目名: string) {
    return {'input-error': this.検索条件バリデーション結果.hasError(項目名)};
  }

  private エラー判定(行番号: number, 項目名: string): boolean {
    if (!this.入庫候補商品一覧[行番号].選択) {
      return false;
    } else {
      return this.商品バリデーション結果.hasError(項目名, 行番号);
    }
  }

  private エラースタイル(行番号: number, 項目名: string) {
    return {'input-error': this.商品バリデーション結果.hasError(項目名, 行番号)};
  }

  private 閉じる() {
    this.beforeOpened = false;
    this.$modal.hide('入庫商品追加画面');
    this.$emit('cancel-item-search');
  }

  private async 確定ハンドラ(): Promise<void> {
      if (this.商品バリデーション結果.hasErrors) {
        this.$emit('show-alert', this.商品バリデーション結果.getMessages(true));
        return;
      }

      const 選択済み商品 = this.入庫候補商品一覧.filter((商品: 入庫候補商品型) => 商品.選択);
      if (選択済み商品.length < 1) {
        this.$emit('show-alert', '確定対象が存在しません');
        return;
      }
      await progress(this.確定する);
  }

  private async 確定する(): Promise<void> {
      const 選択済み商品 = this.入庫候補商品一覧.filter((商品: 入庫候補商品型) => 商品.選択);
      const 入庫作成依頼: 入庫作成依頼型 = {入庫登録商品選択一覧: 選択済み商品};
      await api.商品から入庫を生成する(入庫作成依頼)
        .then((response: 入庫入力型[]) => {
          const 商品から作成した入力一覧: 入庫入力型[] = response;
          this.selectItem(商品から作成した入力一覧);
          this.beforeOpened = false;
          this.$modal.hide('入庫商品追加画面');
          this.$emit('ok-item-search');
          this.入庫候補商品一覧 = [];
        }).catch((error: any) => {
          this.$emit('show-alert', error.data.message);
        });
  }

  @Emit() private selectItem(入庫入力一覧: 入庫入力型[]) {
      return;
  }

  private created() {
      this.入庫候補商品一覧 = [];
  }

  private async 検索ハンドラ(): Promise<void> {
    if (this.検索条件バリデーション結果.hasErrors) {
      this.$emit('show-alert', this.検索条件バリデーション結果.getMessages());
      return;
    }

    const 選択済み商品 = this.入庫候補商品一覧.filter((商品: 入庫候補商品型) => 商品.選択);
    if (選択済み商品.length > 0) {
      this.ダイアログを開く('商品追加選択中確認ダイアログ');
      return;
    }

    await progress(this.検索する);
  }

  private async 確認後の検索するハンドラ() {
    this.ダイアログを閉じる('商品追加選択中確認ダイアログ');
    await progress(this.検索する);
  }

  private ダイアログを開く(name: string): void {
    this.$modal.show(name);
  }

  private ダイアログを閉じる(name: string): void {
    this.$modal.hide(name);
  }

  private async 検索する(): Promise<void> {
    await api.入庫候補商品を検索する(this.入庫候補商品検索条件)
      .then((response: 入庫候補検索結果型) => {
        this.入庫候補商品一覧 = response.入庫商品一覧;
        this.選択中の行index = null;
        if (this.入庫候補商品一覧.length === 0) {
          this.$emit('show-alert', '検索結果が0件です。');
          return;
        }
        if (response.アラートメッセージ) {
          this.$emit('show-alert', response.アラートメッセージ);
        }
      })
      .catch((error: any) => {
        this.$emit('show-alert', error.data.message);
      });
  }

  private マスタ選択区分が採用品以外(): boolean {
    return this.入庫候補商品検索条件.マスタ検索区分 !== 入庫マスタ選択区分型.採用品;
  }

  private マスタ検索区分変更後の処理() {
    this.入庫候補商品検索条件.卸コード = '';

    if (this.マスタ選択区分が採用品以外()
        && this.入庫候補商品検索条件.商品ソート区分 === '仕入先') {
      this.入庫候補商品検索条件.商品ソート区分 = '商品名';
    }
  }

  private 商品ソート区分一覧を取得(): 商品ソート区分型[] {
      if (this.マスタ選択区分が採用品以外()) return 仕入先を抜いた商品ソート区分一覧;
      return 商品ソート区分一覧;
  }

  private マスタ選択区分一覧を取得(): 入庫マスタ選択区分型[] {
    return [
      入庫マスタ選択区分型.採用品,
      入庫マスタ選択区分型.医薬品,
      入庫マスタ選択区分型.その他品,
    ];
  }

  private 全選択する() {
    this.選択を全て変更する(true);
  }

  private 全解除する() {
    this.選択を全て変更する(false);
  }

  private 選択を全て変更する(選択: boolean) {
    for (const 入庫候補 of this.入庫候補商品一覧) {
      入庫候補.選択 = 選択;
    }
    this.$forceUpdate();
  }

  private async リスト選択時の処理(index: number) {
    this.選択中の行index = index;
  }

  private 行が選択されている(index: number) {
    return this.選択中の行index === index;
  }

  @Watch('modal')
  private ダイアログ表示状態変更(nowModal: boolean, prevModal: boolean) {
    if (nowModal === true) {
      this.入庫候補商品一覧 = [];
      this.入庫候補商品検索条件 = this.検索条件初期値を取得();
      this.選択中の行index = null;
      this.$modal.show('入庫商品追加画面');
    }
  }

  private 検索条件初期値を取得(): 入庫候補検索条件型 {
    return {
      マスタ検索区分: 入庫マスタ選択区分型.採用品,
      卸コード: '',
      商品ソート区分: '商品名',
      メーカー名: '',
      商品名カナ: '',
      取得件数: 100,
      取得開始位置: 0,
    };
  }

  private 採用区分をマスタ選択区分に変換する(採用区分: string): マスタ選択区分型 {
    return (採用区分 === '採用') ? マスタ選択区分型.採用品 : マスタ選択区分型.指定なし;
  }

  private get 表示件数を取得() {
    return this.入庫候補商品一覧.length;
  }

  private 入力欄を指定(): any {
    return this.$refs;
  }

  private 次の行の数量に移動(index: number, keyCode: number, repeat: boolean): void {
    if (keyCode !== 13) return;
    if (repeat === true) return;
    this.次の行index = index + 1;
    this.グリッド最終行 = (this.表示件数を取得) - 1;
    if (this.グリッド最終行 >= this.次の行index) {
      this.入力欄を指定().数量入力欄[this.次の行index].$el.childNodes[0].focus();
      this.リスト選択時の処理(this.次の行index);
    } else {
      this.入力欄を指定().数量入力欄[index].$el.childNodes[0].blur();
    }
    this.数量フォーカス移動時選択チェック(index);
  }

  private 数量フォーカス移動時選択チェック(index: number): void {
    if (this.入庫候補商品一覧[index].入庫数 > 0) {
      this.入庫候補商品一覧[index].選択 = true;
    } else {
      this.入庫候補商品一覧[index].選択 = false;
    }
  }

}
